import { Navigate } from "react-router-dom";

export const RedirectUnallowed = (path = "") => {
  return <Navigate to={path} />;
};
